export enum GlobalAccessLevel {
  Restricted = 0,
  Unlisted = 1,
  Public = 2,
}
